import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import moment from 'moment'
import { models } from '@jessicarobins/lineaday'

import auth from './auth'
import editing from './editing'
import lines from './lines'
import prompts from './prompts'
import site from './site'
import subscription from './subscription'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

const FREE_IMAGE_COUNT = 5
const promptDateFormat = 'MMMM D'
const today = moment().format(promptDateFormat)

export default new Vuex.Store({
  state: {

  },
  modules: {
    auth,
    editing,
    lines,
    prompts,
    site,
    subscription
  },
  mutations: {

  },
  plugins: debug ? [createLogger()] : [],
  actions: {

  },
  getters: {
    hasMaxImages: (state, getters, rootState, rootGetters) => !rootGetters.hasSubscription
      && (state.auth.settings.imageCount >= FREE_IMAGE_COUNT),
    prompt: state => models.prompt.getPromptForType({
      date: today,
      promptType: state.auth.settings.promptType,
      dailyPrompts: state.prompts.prompts,
      dailyPromptsMorning: state.prompts.promptsMorning,
    }),
    promptForDay: state => date => models.prompt.getPromptForType({
      date,
      promptType: state.auth.settings.promptType,
      dailyPrompts: state.prompts.prompts,
      dailyPromptsMorning: state.prompts.promptsMorning,
    })
  }
})
